export class HttpError extends Error {
    body: string;

    constructor(message: string, body: string) {
        super(message);
        this.body = body;
    }
}